
// export const BASE_URL = "https://employee.works-reddensoft.com/admin";
// export const BASE_URL = "https://works-reddensoft.com/hrms_demo/admin";

// export const API_IMAGE_PATH =
  // "https://employee.works-reddensoft.com/admin/public/Pdf/";
  // "https://works-reddensoft.com/hrms_demo/admin/public/Pdf/";

// export const BASE_URL = "https://employee.works-reddensoft.com/admin";

// export const API_IMAGE_PATH =
//   "https://employee.works-reddensoft.com/admin/public/Pdf/";



//export const BASE_URL = 'https://phpstack-721645-2691151.cloudwaysapps.com/admin';


// export const BASE_URL = 'http://127.0.0.1:8000/api';
// export const BASE_URL_POP = 'http://127.0.0.1:8000/';
// export const BASE_URL = 'https://works-reddensoft.com/hrms-latest/admin-backend/api';
// export const BASE_URL_POP = 'https://works-reddensoft.com/hrms-latest/admin-backend/public/';
// export const BASE_URI = 'http://127.0.0.1:8080';



export const BASE_URL = 'https://hrms-latest.works-reddensoft.com/admin-backend/api';
export const BASE_URL_POP = 'https://hrms-latest.works-reddensoft.com/admin-backend/public/';
export const BASE_URI = 'https://hrms-latest.works-reddensoft.com';

// export const BASE_URL = 'http://127.0.0.1:8000/api';
// export const BASE_URL_POP = 'http://127.0.0.1:8000/';
// export const BASE_URI = 'http://127.0.0.1:8080';


